import {Box, AppBar, Toolbar, IconButton, Typography} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const CustomizedAppBar = (props) => {
    const { title, onBackButtonClick } = props

    return <Box sx={{ flexGrow: 1, height: "auto" }} className="app-bar">
    <AppBar position="static" style={{ background: '#fbd200', color: "#000" }}>
      <Toolbar>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="back"
          sx={{ mr: 2 }}
          onClick={onBackButtonClick}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          {title}
        </Typography>
      </Toolbar>
    </AppBar>
  </Box>
}

export default CustomizedAppBar;